export default __webpack_public_path__ + "static/media/safaristep.28103531.PNG";